import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=2a9e70de&scoped=true&"
import script from "./wangeditor.vue?vue&type=script&lang=js&"
export * from "./wangeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e70de",
  null
  
)

export default component.exports